import type { Student } from '~/@entities/Student'
import type {
  CommonResponseLectureResponse,
  CommonResponseListBigChapterLectureResponse,
  CommonResponseWatchResponse,
  GetGroupedLectureByCurriculumKeyParams,
} from '~/api-spec/__generated__/main'
import { httpClient, type RequestMeta } from '~/http/client'

import { adaptLecture, adaptLectureGroups, adaptWatchedLectures } from './adapters'
import type { Lecture, LectureGroup } from './schemas'

export type { GetGroupedLectureByCurriculumKeyParams }

export const getLectureGroups = async (
  params: GetGroupedLectureByCurriculumKeyParams,
  meta?: RequestMeta,
): Promise<LectureGroup[]> => {
  const body = await httpClient().get<CommonResponseListBigChapterLectureResponse>(
    '/lecture/group',
    {
      params,
      meta,
    },
  )
  return adaptLectureGroups(body.data) ?? []
}

export const getLecture = async (
  lectureId: Lecture['id'],
  meta?: RequestMeta,
): Promise<Lecture> => {
  const body = await httpClient().get<CommonResponseLectureResponse>(`/lecture/${lectureId}`, {
    meta,
  })
  return adaptLecture(body.data)
}

export const getWatchedLectureIds = async (
  studentId: Student['id'],
  meta?: RequestMeta,
): Promise<Lecture['id'][]> => {
  const body = await httpClient().get<CommonResponseWatchResponse>(
    `/student-lecture/${studentId}`,
    { meta },
  )
  return (adaptWatchedLectures(body.data) ?? { lectureIds: [] }).lectureIds
}
